import React, { Component } from 'react';
import { defaultHeaders } from './util';
import {Header} from './header.js';
import {Footer} from './footer.js';
import * as util from "./util";
import { ProductRating, ProductDetailsButtons, ProductDescriptionDocument,
         ProductReviews, ProductPrice, CommUserInfo, ProductMediaMultiParent, ProductTypeWithoutParantheses, ProductTypeWithLabel} from './product-details';
import './product.css';
import { CategoryPathWithLabel} from './show-categorypath.js';

let faqProductDetails = [
  {
    content: "Wir bieten <u>kostenfreie</u> Auftragssuchen an. Klicken Sie <a class='fontColorBlue' target='_blank' href='/contact/#contactform'>hier</a>.",
    title: "Nicht fündig geworden?",
    key: 0
  }
];



export class DocumentDetails extends Component {
  constructor(props) {
    super(props);
    this.getDocumentDetails = this.getDocumentDetails.bind(this);

    this.state = {
      id: this.props.match.params.id,
      name: '',
      type: 'Dokument',
      board: '',
      uuid: '',
      categories: '',
      price: 0,
      doctype: '',
      aim: '',
      content: '',
      links: '',
      target: '',
      specialties: '',
      usage: '',
      review1: '',
      review2: '',
      tags: [],
      pdf_files: '',
      image_files: '',
      video_files: '',
    }

    if (!util.isCommercialUser() && !util.isNonCommercialUser() && this.id !== undefined) {
      util.loginGuest( () => this.getDocumentDetails(this.state.id));
    } else {
      this.getDocumentDetails(this.state.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    const newID = parseInt(nextProps.id, 10);
    const oldID = parseInt(this.state.id, 10);
    if (oldID !== newID) {
      this.getDocumentDetails(newID);
      this.setState({ id: newID });
    }
  }

  getDocumentDetails(productID) {
    const self = this;
    const url = `/api/show-document?id=${productID}`;
    const headers = defaultHeaders();
    headers.append("Accept", "application/json");
    var promise = fetch(url, {
      method: 'GET',
      headers: headers
    }).then(response => response.json())
      .catch(function (exception) {
        console.error('Could not document details.', exception);
      });

    promise.then(function (json) {
      localStorage.setItem('product-name', json.name);
      self.setState({
        name: (json.name ? json.name : '(kein Name)'),
        board: json.board ? json.board : '',
        uuid: json.uuid ? json.uuid : '',
        categories: (json.categories ? json.categories : '(kein Name)'),
        price: (json.price !== undefined ? json.price : '(keine Angabe)'),
        doctype: (json.doctype ? json.doctype : '(von unbekanntem Typ)'),
        aim: (json.aim ? json.aim : '(keine Angabe)'),
        content: (json.content ? json.content : '(keine Angabe)'),
        links: (json.links ? json.links : '(keine Angabe)'),
        target: (json.target ? json.target : '(keine Angabe)'),
        specialties: (json.specialties ? json.specialties : '(keine Angabe)'),
        usage: (json.usage ? json.usage : '(keine Angabe)'),
        review1: (json.review1 ? json.review1 : '(keine Angabe)'),
        review2: (json.review2 ? json.review2 : '(keine Angabe)'),
        tags: (json.tags ? json.tags : '(keine Angabe)'),
        pdf_files: (json.pdf_files ? json.pdf_files : '(keine Angabe)'),
        image_files: (json.image_files ? json.image_files : '(keine Angabe'),
        video_files: (json.video_files ? json.video_files : '(keine Angabe)'),
      });
      return;
    });
    return;
  }
  render() {
    return (
      <div className="Landing" id="contentId">
        <Header username={this.props.username} propagateLogin={this.props.propagateLogin} />
        <div className="ContentWithBackground">
          <div className="content" id="content">
            <div className="productHeader1">
              {/* <ProductType name={this.state.name} productType={this.state.type} />*/}
              <ProductTypeWithoutParantheses name={this.state.name} />
            </div>

             <ProductDetailsButtons board={this.state.board} productID={this.state.id} productType={this.state.type} productName={this.state.name} price={this.state.price} history={this.props.history} />
         
            <div className="productInfoHeader">

              {util.isGuestUser() && <h3>Viele Angebote im Marktplatz sind kostenfrei - falls etwas kostenpflichtig sein sollte, sind Preise nur für eingeloggte Nutzer sichtbar.</h3>}
              <ProductTypeWithLabel  productType={this.state.type} />
              <CommUserInfo id={this.state.id} table={"document"}/>
              <CategoryPathWithLabel ids={this.state.categories} startID={2} />
              {/* <CategoryPath ids={this.state.categories} startID={2} /> */}
              <ProductRating uuid={this.state.uuid} />
              {!util.isGuestUser() && <ProductPrice price={this.state.price} />}
            </div>


            <ProductTabsDocument
                uuid={this.state.uuid}
                productID={this.state.id}
                aim={this.state.aim}
                doctype={this.state.doctype}
                content={this.state.content}
                links={this.state.links}
                target={this.state.target}
                specialties={this.state.specialties}
                usage={this.state.usage}
                review1={this.state.review1}
                review2={this.state.review2}
                tags={this.state.tags}
                pdf_files={this.state.pdf_files}
                image_files={this.state.image_files}
                video_files={this.state.video_files}
            />
            {/*<InfoBar faq={faqProductDetails} />*/}
            <ProductDetailsButtons board={this.state.board} productID={this.state.id} productType={this.state.type} productName={this.state.name} price={this.state.price} history={this.props.history} />
          </div>
        </div>
        <Footer faqs={faqProductDetails}/>
      </div>
    );
  }

}

class ProductTabsDocument extends Component {
  constructor(props) {
    super(props);
    this.makeActive = this.makeActive.bind(this);
    this.state = { activeTab: 0 };
  }

  makeActive(i) {
    this.setState({ activeTab: i });
  }

  render() {
    return (
      <div className="ProductTabs">
        <div className="ProductTabsButtons">
          <button className={this.state.activeTab === 0 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(0)} >Beschreibung</button>
          <button className={this.state.activeTab === 1 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(1)} >Reviews</button>
          <button className={this.state.activeTab === 2 ? "ProductTabsButton active" : "ProductTabsButton"} onClick={event => this.makeActive(2)} >Medien</button>
          <ProductDescriptionDocument style={this.state.activeTab === 0 ? null : { display: 'none' }}
                                      aim={this.props.aim}
                                      doctype={this.props.doctype}
                                      content={this.props.content}
                                      links={this.props.links}
                                      target={this.props.target}
                                      specialties={this.props.specialties}
                                      usage={this.props.usage}
                                      review1={this.props.review1}
                                      review2={this.props.review2}
                                      tags={this.props.tags}
          />
          <ProductReviews uuid={this.props.uuid} style={this.state.activeTab === 1 ? null : { display: 'none' }} />
          <ProductMediaMultiParent style={this.state.activeTab === 2 ? null : { display: 'none' }}
                                   heading1={'Dokumentation'}
                                   uuids1={this.props.pdf_files}
                                   heading2={'Beschreibende Bilder oder Screenshots'}
                                   uuids2={this.props.image_files}
                                   heading3={'Video'}
                                   uuids3={this.props.video_files}
          />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/document-details.js